import { render } from "./AppImageCard.vue?vue&type=template&id=1f35463b&scoped=true&ts=true"
import script from "./AppImageCard.vue?vue&type=script&lang=ts"
export * from "./AppImageCard.vue?vue&type=script&lang=ts"

import "./AppImageCard.vue?vue&type=style&index=0&id=1f35463b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f35463b"]])

export default __exports__